import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AddStaticImagePathPipe, SafeHtmlPipe } from '@mwe/ui/pipes';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { NavbarHeaderComponent } from '../layout/navbar/navbar-header.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mwe-maintenance-template',
  templateUrl: './maintenance-template.component.html',
  imports: [TranslatePipe, SafeHtmlPipe, AddStaticImagePathPipe, BasicCardComponent, NavbarHeaderComponent, NgClass],
})
export class MaintenanceTemplateComponent {
  readonly headline = input<string>(null);
  readonly subheadline = input<string>(null);
  readonly text = input<string>(null);
  readonly information = input<string>(null);
  readonly isBtnVisible = input<boolean>(true);
  readonly buttonLabelkey = input<string>(null);
  readonly isHeaderNavigationVisible = input<boolean>(false);
  readonly buttonClick = output();
}
